import React, { useMemo } from 'react';
import FetchData from './FetchData';
import Line from '../svg/Line';

const GraphContainer = ({
  route,
  setData,
  data,
  title,
  xAxisLabel,
  yAxisLabel,
  xDomain,
  yValueAccessor,
  lineColor,
  timeKeyField,
  timeFormat,
  processData,
  startDate,
  endDate,
  zoomTransform,
  onZoom,
  bindGraphGesture, // Gesture binding function
  dragShift, // Optional drag shift function
  onHover,
}) => {
  // Memoize the data to avoid unnecessary re-renders
  const memoizedData = useMemo(() => data, [data]);

  // Memoize all props passed to FetchData to ensure stability
  const fetchDataProps = useMemo(() => ({
    route,
    setData,
    startDate,
    endDate,
    timeKeyField,
    timeFormat,
    processData,
  }), [route, setData, startDate, endDate, timeKeyField, timeFormat, processData]);

  // Memoize gesture bindings to avoid unnecessary re-renders
  const memoizedBindGraphGesture = useMemo(() => bindGraphGesture(), [bindGraphGesture]);

 // Memoize props for the Line component
  const lineProps = useMemo(() => ({
    data: memoizedData,
    title,
    xAxisLabel,
    yAxisLabel,
    xDomain,
    yValueAccessor,
    lineColor,
    zoomTransform,
    onZoom,
    dragShift,
    onHover,
  }), [
    memoizedData,
    title,
    xAxisLabel,
    yAxisLabel,
    xDomain,
    yValueAccessor,
    lineColor,
    zoomTransform,
    onZoom,
    dragShift,
    onHover,
  ]);
  return (
    <>
      {/* Fetch data from the API */}
      <FetchData {...fetchDataProps} />
      {/* Graph container with gesture bindings */}
      <div
        className="graph-container"
        {...memoizedBindGraphGesture} // Apply memoized gesture bindings
        style={{
          touchAction: 'none', // Prevent default touch actions
        }}
      >
        {/* Render the Line component */}
        <Line {...lineProps} />
      </div>
    </>
  );
};

export default React.memo(GraphContainer);